import { PrismicRichText } from '@prismicio/react';
import CheckIcon from '@remote-com/norma/icons/check.svg';
import CloseIcon from '@remote-com/norma/icons/times.svg';
import ContentContainer from 'remote-com-shared/components/ContentContainer';

import TableCheckIcon from './assets/check-label.svg';

import { fieldHasContent, transformProperties } from '@/src/domains/prismic/helpers';
import {
  Section,
  ComparisonTableWrapper,
  ThirdTableHeading,
  CheckIconWrapper,
  CloseIconWrapper,
  SecondComparisonTableWrapper,
  TableRowItem,
  TableHeading,
  ThirdColumnTitle,
  TableRow,
  ThirdTableRow,
  Title,
  Header,
  Note,
  TableLeftBgWrapper,
  TableRightBgWrapper,
} from '@/src/views/EmploymentFAQ/styles';
import { TableRowHeading, Table } from '@/src/views/EntityCost/ComparisonTableSlice';

export function TableSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { sectionTitle, tableHeadingColumn2, tableHeadingColumn3 } = primary;

  const { fields: sections } = slice;

  return (
    <Section id="comparison-table">
      <ContentContainer>
        <Header>
          <TableCheckIcon />
          {fieldHasContent(sectionTitle) && (
            <Title>
              <PrismicRichText field={sectionTitle} />
            </Title>
          )}
        </Header>
        <ComparisonTableWrapper>
          <Table>
            <TableRow>
              <TableHeading />
              <TableHeading>{tableHeadingColumn2}</TableHeading>
              <ThirdColumnTitle>{tableHeadingColumn3}</ThirdColumnTitle>
            </TableRow>
            {sections.map(
              (
                {
                  entry_column_1: firstDescription,
                  entry_column_2: secondDescription,
                  entry_column_3: thirdDescription,
                  column_2_note: secondNote,
                  column_3_note: thirdNote,
                },
                index
              ) => (
                <TableRow key={index}>
                  <TableRowItem>
                    {firstDescription && <TableRowHeading>{firstDescription}</TableRowHeading>}
                  </TableRowItem>
                  {fieldHasContent(secondNote) || fieldHasContent(thirdNote) ? (
                    <TableRowItem>
                      <Note>
                        <PrismicRichText field={secondNote} />
                      </Note>
                    </TableRowItem>
                  ) : (
                    <TableRowItem>
                      {secondDescription ? (
                        <CheckIconWrapper>
                          <CheckIcon />
                        </CheckIconWrapper>
                      ) : (
                        <CloseIconWrapper>
                          <CloseIcon />
                        </CloseIconWrapper>
                      )}
                    </TableRowItem>
                  )}
                  {fieldHasContent(secondNote) || fieldHasContent(thirdNote) ? (
                    <TableRowItem>
                      <Note>
                        <PrismicRichText field={thirdNote} />
                      </Note>
                    </TableRowItem>
                  ) : (
                    <TableRowItem>
                      {thirdDescription ? (
                        <CheckIconWrapper>
                          <CheckIcon />
                        </CheckIconWrapper>
                      ) : (
                        <CloseIconWrapper>
                          <CloseIcon />
                        </CloseIconWrapper>
                      )}
                    </TableRowItem>
                  )}
                </TableRow>
              )
            )}
          </Table>
        </ComparisonTableWrapper>

        {/* 
        on smaller screens ComparisonTableWrapper displays only first two columns, and in SecondComparisonTableWrapper first and third columns
        */}

        <SecondComparisonTableWrapper>
          <Table>
            <TableRow>
              <TableHeading />
              <ThirdTableHeading>{tableHeadingColumn3}</ThirdTableHeading>
            </TableRow>
            {sections.map(
              (
                {
                  entry_column_1: firstDescription,
                  entry_column_3: thirdDescription,
                  column_2_note: secondNote,
                  column_3_note: thirdNote,
                },
                index
              ) => (
                <ThirdTableRow key={index}>
                  <TableRowItem>
                    <TableRowHeading>{firstDescription}</TableRowHeading>
                  </TableRowItem>
                  {fieldHasContent(secondNote) || fieldHasContent(thirdNote) ? (
                    <TableRowItem>
                      <Note>
                        <PrismicRichText field={thirdNote || secondNote} />
                      </Note>
                    </TableRowItem>
                  ) : (
                    <TableRowItem>
                      {thirdDescription ? (
                        <CheckIconWrapper>
                          <CheckIcon />
                        </CheckIconWrapper>
                      ) : (
                        <CloseIconWrapper>
                          <CloseIcon />
                        </CloseIconWrapper>
                      )}
                    </TableRowItem>
                  )}
                </ThirdTableRow>
              )
            )}
          </Table>
        </SecondComparisonTableWrapper>
      </ContentContainer>

      <TableLeftBgWrapper />
      <TableRightBgWrapper />
    </Section>
  );
}
